import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'
import JustForYouContainer from 'components/just-for-you'
import CommonLayout from 'components/layout/common'
import { withI18next } from 'lib/i18n/withI18next'
import { Error } from 'pages/_error'
import { PAGE_NAME } from 'pages/const'
import BasePage from 'pages/base'
import ScrollToTop from 'components/shared/scroll-to-top/ScrollToTop'

const JustForYou = ({ auth, isPhone, productId, refType }) => {
  if (!productId) {
    return <Error />
  }

  return (
    <CommonLayout pageName={PAGE_NAME.justForYou}>
      <ScrollToTop />
      <JustForYouContainer
        auth={auth}
        refType={refType}
        isPhone={isPhone}
        productId={parseInt(productId, 10)}
      />
    </CommonLayout>
  )
}

JustForYou.getInitialProps = ({ store, req, res, query, isServer }) => {
  const { id_product: productId, refType } = query

  if (isServer) {
    BasePage.loadInitialContentFromServer({ req, res, store })
  } else {
    BasePage.loadInitialContentFromClient(req, res, store)
  }
  return { productId, refType }
}

JustForYou.defaultProps = {
  refType: '',
}

JustForYou.propTypes = {
  refType: PropTypes.string,
  isPhone: PropTypes.bool.isRequired,
  auth: PropTypes.shape({}).isRequired,
  productId: PropTypes.string.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    auth: state.auth,
  })),
  withI18next(),
)(JustForYou)
